export default "__VITE_ASSET__BFsCt5tb__"